import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import Brand from "../Json/Brand.json";
import { GetAllProductViewd } from "../features/RecentlyViewed/RecentlyViewed";
import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  LoadingNumber,
  resetLoadingNumber,
  getAllProductOnline,
  getLastDoc,
  SetBottomSizeFilter,
} from "../features/Products/ProductSlice";
import branch from "branch-sdk";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { useTranslation } from "react-i18next";
import {
  collection,
  convertGlobalPrice,
  db,
  getDocs,
  query,
  where,
} from "../utils/firebase/firebase.utils";
import Conditions from "../Json/Conditions.json";
import { limit } from "firebase/firestore";
import algoliasearch from "algoliasearch";
function TopPicksSeacrh() {
  const dispatch = useDispatch();
  const [activeThumb, setActiveThumb] = useState();
  const { products, isTopPicks } = useSelector((store) => store.allproducts);
  const { flags, constant } = useSelector((store) => store.flags);
  const { currencies, selectedcurrency, currencydefault, countryCode } =
    useSelector((store) => store.currency);
  const [topPicks, setTopicks] = useState([]);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  var arrayFortSort = [...products.filter((product) => product.userLikes)];
  const now = new Date();
  var datenow = new Date();
  datenow.setDate(now.getDate());

  const isLessThan90 = (date) => {
    if ("toDate" in date) {
      return (datenow - date.toDate()) / (1000 * 3600 * 24) < 90;
    } else {
      return false;
    }
  };
  var TopPicks;
  if (arrayFortSort.length != 0) {
    TopPicks = arrayFortSort
      .sort((a, b) => b.userLikes.length - a.userLikes.length)
      .filter(
        (name) =>
          name.userLikes.length != 0 &&
          name.status === "Live" &&
          isLessThan90(name.date)
      );
  }
  var isFlash = false;

  if (flags.filter((flag) => flag.id === "offers")[0]) {
    const endDate = flags.filter((flag) => flag.id === "offers")[0]
      .endFlashSale;
    const startDate = flags.filter((flag) => flag.id === "offers")[0]
      .startFlashSale;
    isFlash =
      "toDate" in endDate && "toDate" in startDate
        ? flags.filter((flag) => flag.id === "offers")[0].isFlashSale &&
          startDate.toDate() <= Date.now() &&
          endDate.toDate() >= Date.now()
        : false;
  }
  function ShopTopPicks() {
    dispatch(GetProductJustViewdd([]));
    dispatch(GetProductAlsoLike([]));
    dispatch(GetProductFromSeller([]));
    dispatch(GetProductNewDrops([]));
    dispatch(GetAllProductViewd([]));
    dispatch(GetLibasProduct([]));
    dispatch(GetAllProductVintage([]));
    dispatch(GetAllChanel([]));
    dispatch(GetAllAmina([]));
    dispatch(GetAllPradaReEdition([]));
    dispatch(GetAllChanelBoy([]));
    dispatch(GetAllBottega([]));
    dispatch(GetAllHermes([]));
    dispatch(GetAllBirkin([]));
    dispatch(GetAllBurberry([]));
    dispatch(IsBurberry(false));
    // dispatch(LoadingNumber(30))

    dispatch(GetAllDG([]));
    dispatch(IsDG(false));

    dispatch(GetAllLV([]));
    dispatch(IsLV(false));

    dispatch(GetAllDisel([]));
    dispatch(IsDisel(false));

    dispatch(GetAllGucci([]));
    dispatch(IsGucci(false));

    dispatch(GetAllMM([]));
    dispatch(IsMM(false));

    dispatch(GetAllZadig([]));
    dispatch(IsZadug(false));
    dispatch(IsJustView(false));
    dispatch(IsTopPicks(false));
    dispatch(IsProductFromSeller(false));
    dispatch(IsProductAlsoLike(false));
    dispatch(IsProductLibas(false));
    dispatch(IsVintage(false));
    dispatch(IsChanel(false));
    dispatch(IsAmina(false));
    dispatch(IsPradaReEdition(false));
    dispatch(IsChanelBoy(false));
    dispatch(IsBottega(false));
    dispatch(IsHermes(false));
    dispatch(IsBirkin(false));
  }
  const handleClick = () => {
    window.location.reload(); // recommended
    //window.location.href = window.location.href;  // not recommended
  };

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  const today = new Date();

  const LessThan90DaysAgo = new Date(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate() - 90
  );
  const getProductsWithLikesAndStatus = async () => {
    try {
      if (constant.isAlgoliaEnabledWeb) {
        const client = algoliasearch(
          process.env.REACT_APP_AlGOLIA_APP_ID,
          process.env.REACT_APP_ALGOLIA_API_KEY
        );
        const LessThan90DaysAgoTimestamp = Math.floor(
          LessThan90DaysAgo.getTime() / 1000
        );
        const index = client.initIndex(
          process.env.REACT_APP_ALGOLIA_INDEX_NEWEST
        );
        const hitsPerPage = 4; // Limit the number of results to 4

        const theQuery = {
          //filters: 'status:Live AND dateApproved <= ' + LessThan90DaysAgoTimestamp,
          hitsPerPage: hitsPerPage,
        };
        const snapshot = await index.search("", theQuery);
        const data = snapshot.hits.map((hit) => ({
          id: hit.objectID,
          ...hit,
        }));

        setTopicks(data);
      } else {
        const productQuery = query(
          collection(db, "product"),
          where("status", "==", "Live"),
          where("dateApproved", "<=", LessThan90DaysAgo),
          limit(4)
        );

        const querySnapshot = await getDocs(productQuery);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setTopicks(data);
      }

      // Now you can use sortedAndFilteredProducts as needed.
    } catch (error) {
      console.error("Error retrieving and filtering products:", error);
    }
  };
  useEffect(() => {
    getProductsWithLikesAndStatus();
    // dispatch(getAllProductOnline(topPicks))
    console.log("2");
  }, []);
  // console.log('selectedcurrency',selectedcurrency);
  // console.log('currencydefault',currencydefault);
  return (
    <>
      <div className="searchtitle pt-4 pb-4" style={arabStyle}>
        {t("TOPPICKS")}
      </div>
      <div className="row mx-0  ">
        <div className="col-12 px-0 ">
          {
            // props.images.map((item, index) => (
            <>
              {topPicks &&
                topPicks.slice(0, 4).map((item) => (
                  <div
                    key={item.id}
                    onClick={() =>
                      navigate(`/product/${item.id}`) &
                      dispatch(SetSizeFilter([])) &
                      dispatch(SetTopSizeFilter([])) &
                      dispatch(SetBottomSizeFilter([])) &
                      dispatch(getAllProductOnline([])) &
                      dispatch(getLastDoc(null)) &
                      SetSelectdPage(0) &
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                      }) &
                      branch.track("SelectItem", {
                        id: item.id,
                        price: item.price,
                        currency: item.idCurrency,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className=" row mx-2   pb-4 align-items-center d-flex">
                      <div className="col-md-4 col-5 justify-content-center d-flex  px-0">
                        <img
                          src={item.frontImage}
                          alt="product images"
                          className={`img-topPicksseacrh ${
                            i18n.language == "en" ? " me-4" : " "
                          }`}
                        />
                      </div>

                      <div
                        className="col-md-8 col-7 px-0"
                        style={{
                          fontFamily: "Montserrat-SemiB",
                          fontSize: "9px",
                        }}
                      >
                        <div className="brand-search pb-1">
                          {i18n.language == "en"
                            ? item.nameBrand
                            : Brand.filter(
                                (brand) => brand.name == item.nameBrand
                              ).length != 0
                            ? Brand.filter(
                                (brand) => brand.name == item.nameBrand
                              ).map((brand) => brand.nameAr)
                            : item.nameBrand}
                        </div>
                        <div className="model-search">{item.nameModel}</div>
                        <div
                          className="pt-3 pb-3"
                          style={{
                            fontFamily: "Montserrat-SemiB",
                            fontSize: "9px",
                          }}
                        >
                          {currencies.length === 0 ? null : (
                            <Currency
                              data={flags}
                              isFlash={isFlash}
                              price={convertGlobalPrice(
                                item.idCurrency,
                                item.price,
                                !selectedcurrency
                                  ? currencydefault
                                  : selectedcurrency,
                                currencies,
                                countryCode
                              )} //{CoverToAED(item.price,curr.toUSD)}
                              dealPrice={
                                !item.dealPrice
                                  ? null
                                  : convertGlobalPrice(
                                      item.idCurrency,
                                      item.dealPrice,
                                      !selectedcurrency
                                        ? currencydefault
                                        : selectedcurrency,
                                      currencies,
                                      countryCode
                                    )
                              } //{CoverToAED(item.dealPrice,curr.toUSD)}
                              discountedPrice={
                                !item.discountedPrice
                                  ? null
                                  : convertGlobalPrice(
                                      item.idCurrency,
                                      item.discountedPrice,
                                      !selectedcurrency
                                        ? currencydefault
                                        : selectedcurrency,
                                      currencies,
                                      countryCode
                                    )
                              } //{CoverToAED(item.discountedPrice,curr.toUSD)}
                              card={item}
                              TypeCurrency={
                                !selectedcurrency
                                  ? i18n.language == "en"
                                    ? currencies.filter(
                                        (currency) =>
                                          currency.id === currencydefault
                                      )[0].name
                                    : currencies.filter(
                                        (currency) =>
                                          currency.id === currencydefault
                                      )[0].nameAr
                                  : i18n.language == "en"
                                  ? currencies.filter(
                                      (currency) =>
                                        currency.id === selectedcurrency
                                    )[0].name
                                  : currencies.filter(
                                      (currency) =>
                                        currency.id === selectedcurrency
                                    )[0].nameAr
                              }
                            />
                          )}
                        </div>
                        <div className="model-search">
                          {t("Condition")}:{" "}
                          {Conditions.filter(
                            (cond) => cond.id == item.idCondition
                          ).map(
                            (cond) =>
                              cond.name && cond.name.replace("condition", "")
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </>
            // ))
          }
        </div>
      </div>

      <div className="text-center  w-100 mx-2">
        <button
          className="btn-seacrh"
          type="submit"
          onClick={() =>
            ShopTopPicks() &
            // dispatch(getAllProductOnline(topPicks))&
            // dispatch(getAllProductOnline([]))&dispatch(getLastDoc(null))&
            dispatch(IsTopPicks(true)) &
            navigate(`/products?topic=TopPicks`) &
            dispatch(SetSizeFilter([])) &
            dispatch(SetTopSizeFilter([])) &
            dispatch(SetBottomSizeFilter([])) &
            dispatch(getAllProductOnline([])) &
            dispatch(getLastDoc(null)) &
            dispatch(SortProducts("")) &
            dispatch(SetSelectdPage(0)) &
            sessionStorage.setItem("selectedItemIndex", "") &
            dispatch(resetLoadingNumber(30)) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="View All TopPicks Products"
        >
          {t("VIEW ALL")}
        </button>
      </div>
    </>
  );
}

export default TopPicksSeacrh;
export function Currency({
  data,
  price,
  card,
  dealPrice,
  discountedPrice,
  TypeCurrency,
  isFlash,
}) {
  return (
    <>
      {data.isFlashSale === false ? (
        <>
          {!card.discountedPrice ? (
            <>
              {card.status != "Pending" &&
              card.status != "Live" &&
              card.status != "Rejected" ? (
                <div className="sold-price">
                  {new Intl.NumberFormat().format(price)} {TypeCurrency}
                </div>
              ) : (
                <>
                  {new Intl.NumberFormat().format(price)} {TypeCurrency}
                </>
              )}
            </>
          ) : (
            <>
              {card.status != "Pending" &&
              card.status != "Live" &&
              card.status != "Rejected" ? (
                <div className="sold-price">
                  <div className="price-mybag2">
                    {new Intl.NumberFormat().format(discountedPrice)}{" "}
                    {TypeCurrency}
                  </div>
                </div>
              ) : (
                <>
                  <div className="price-mybag2">
                    {new Intl.NumberFormat().format(discountedPrice)}{" "}
                    {TypeCurrency}
                  </div>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {card.isInDeal === true && (
            <>
              {data
                .filter((data) => data.id === "offers")
                .map((data) => (
                  <>
                    {data.isFlashSale && (
                      <>
                        <>
                          {isFlash ? (
                            <>
                              {card.status != "Pending" &&
                              card.status != "Live" &&
                              card.status != "Rejected" ? (
                                <div className="sold-price">
                                  <div className="price-mybag2">
                                    {new Intl.NumberFormat().format(dealPrice)}{" "}
                                    {TypeCurrency}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="price-mybag2">
                                    {new Intl.NumberFormat().format(dealPrice)}{" "}
                                    {TypeCurrency}
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <>
                                {!card.discountedPrice ? (
                                  card.status != "Pending" &&
                                  card.status != "Live" &&
                                  card.status != "Rejected" ? (
                                    <div className="sold-price">
                                      <div className="price-mybag2">
                                        <div>
                                          {new Intl.NumberFormat().format(
                                            price
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <div>
                                        {new Intl.NumberFormat().format(price)}{" "}
                                        {TypeCurrency}
                                      </div>
                                    </>
                                  )
                                ) : (
                                  <>
                                    {card.status != "Pending" &&
                                    card.status != "Live" &&
                                    card.status != "Rejected" ? (
                                      <div className="sold-price">
                                        <div className="price-mybag2">
                                          {new Intl.NumberFormat().format(
                                            discountedPrice
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="price-mybag2">
                                          {new Intl.NumberFormat().format(
                                            discountedPrice
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            </>
                          )}
                        </>
                      </>
                    )}
                  </>
                ))}
            </>
          )}

          {!card.isInDeal && (
            <>
              {!card.discountedPrice ? (
                card.status != "Pending" &&
                card.status != "Live" &&
                card.status != "Rejected" ? (
                  <div className="sold-price">
                    <div className="price-mybag2">
                      {new Intl.NumberFormat().format(price)} {TypeCurrency}
                    </div>
                  </div>
                ) : (
                  <>
                    {card.status != "Pending" &&
                    card.status != "Live" &&
                    card.status != "Rejected" ? (
                      <div className="sold-price">
                        <div className="price-mybag2">
                          {new Intl.NumberFormat().format(price)} {TypeCurrency}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="price-mybag2">
                          {new Intl.NumberFormat().format(price)} {TypeCurrency}
                        </div>
                      </>
                    )}
                  </>
                )
              ) : (
                <>
                  {card.status != "Pending" &&
                  card.status != "Live" &&
                  card.status != "Rejected" ? (
                    <div className="sold-price">
                      <div className="price-mybag2">
                        {new Intl.NumberFormat().format(discountedPrice)}{" "}
                        {TypeCurrency}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="price-mybag2">
                        {new Intl.NumberFormat().format(discountedPrice)}{" "}
                        {TypeCurrency}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
